import { useState } from 'react';
import { Alert, Button, Chip, Group, Modal, Text } from '@mantine/core';
import { slotLabel } from '../../model/derive';
import type { Participant, SlotId } from '../../model/types';

interface AdjustAvailabilityModalProps {
  participant: Participant;
  slots: SlotId[];
  current: SlotId[];
  onSave: (slots: SlotId[]) => void;
  onClose: () => void;
}

/** "Adjust availability: <name>" — turn off times a person can't make. */
export function AdjustAvailabilityModal({
  participant,
  slots,
  current,
  onSave,
  onClose,
}: AdjustAvailabilityModalProps) {
  const [draft, setDraft] = useState<SlotId[]>(current);
  return (
    <Modal
      opened
      onClose={onClose}
      title={`Adjust availability: ${participant.name}`}
      size={520}
      centered
    >
      {participant.availabilityNote && (
        <Alert color="blue" variant="light" mb="md">
          {participant.availabilityNote}
        </Alert>
      )}
      <Text size="sm" c="dimmed" mb="sm">
        Turn off times this person can't make. Matching will skip them.
      </Text>
      <Chip.Group
        multiple
        value={draft}
        onChange={v => setDraft(slots.filter(s => v.includes(s)))}
      >
        <Group gap="sm">
          {slots.map(s => (
            <Chip key={s} value={s} variant="filled">
              {slotLabel(s)}
            </Chip>
          ))}
        </Group>
      </Chip.Group>
      <Group justify="flex-end" mt="xl">
        <Button variant="default" onClick={onClose}>
          Cancel
        </Button>
        <Button
          onClick={() => {
            onSave(draft);
            onClose();
          }}
        >
          Save availability
        </Button>
      </Group>
    </Modal>
  );
}
